import { css } from '@emotion/react';
import { breakpoints } from '../../styles';
import { p2r } from '../../styles/fonts';

const styles = (color) => css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 47%;
  color: ${color};

  @media (max-width: ${breakpoints.tablet}px) {
    width: 100%;
    padding-bottom: ${p2r(35)};
  }
`;

export default styles;
